<template>
  <div ref="echartsContainer" style="width:600px; height: 300px;"></div>
</template>
   
<script>
import * as echarts from "echarts";

export default {
  name: "EChartsComponent",
  props: {
    data: Array
  },
  mounted() {
    let equity_data = [];
    let record_date = [];
    let balance_report_negative = [];
    let balance_report_positive = [];

    this.data.forEach(item => {
      equity_data.push(item.balance); //资金
      record_date.push(item.record_date); //日期
      balance_report_negative.push(item.balance_report_negative); //出金
      balance_report_positive.push(item.balance_report_positive); //入金
    });
    var myChart = echarts.init(this.$refs.echartsContainer);
    myChart.setOption({
      tooltip: {
        trigger: "axis", // 触发类型
        confine: true, //将 tooltip 框限制在图表的区域内。
        textStyle: {
          fontSize: 12,
          color: "#E7EEF8"
        },
        backgroundColor: "#8EA4BD", //设置背景图片 rgba格式
        borderColor: "#2D3D5C",
        formatter: function(params) {
          const index = params[0].dataIndex;
          return `日期：${record_date[index]}<br/>
                  资金：${equity_data[index]}<br/>
                  出金：${balance_report_negative[index] || 0}<br/>
                  入金：${balance_report_positive[index] || 0}`;
        }
      },
      xAxis: {
        type: "category",
        // data: xAxisArr,
        data: record_date,
        // data: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
        axisTick: {
          // 轴刻度
          show: false
        },
        axisLine: {
          // 轴线
          show: false
        }
      },
      axisLabel: {
        // 轴文字
        show: false,
        color: "#888891",
        fontSize: 12
      },
      axisLine: {
        // 轴线
        show: true,
        color: "#888891"
      },

      yAxis: [
        {
          type: "value",
          axisTick: {
            // 轴刻度
            show: false
          },
          axisLine: {
            // 轴线
            show: false
          }
        }
      ],
      // dataset: {
      //   source: this.data,
      // },
      series: [
        {
          data: equity_data,
          // data: [150, 230, 224, 218, 135, 147, 260],
          type: "line",
          // 设置折线颜色
          lineStyle: {
            color: "#268FFF", // 折线颜色
            width: 2 // 折线宽度
          },
          // 设置数据点颜色
          itemStyle: {
            color: "#268FFF", // 数据点颜色
            borderWidth: 4,
            borderColor: "#268FFF"
          }
        }
      ]
    });
  }
};
</script>
<style scoped>
</style>